import { inputLayerGroups } from "fond/layers";
import { DataPrepLayerGroup, DataPrepStatus, getDataPrepStatus, GroupLayer } from "fond/project/panels/RunDataPrep/dataPrepStatus";

const { inAddress, inParcel, inBaseDataStreet, inUnderground, spanPole, inLeadIns } = inputLayerGroups;

const plannerLayerGroups: Record<DataPrepLayerGroup, GroupLayer[]> = {
  inputs: [inAddress, inParcel, inBaseDataStreet].flatMap(({ layers }) => layers),
  underground: inUnderground.layers,
  aerial: spanPole.layers,
  leadins: inLeadIns.layers,
};

/** The current status of planner layer groups relevant to data prep. */
export const getPlannerDataPrepStatus = (layerKeys: string[]): DataPrepStatus =>
  getDataPrepStatus(layerKeys, plannerLayerGroups, ["underground", "aerial"]);
